import { useCallback } from "react";
import apiClientTwo from "../api/apiClient2";
import apiPaths from "../api/endpoints";
import { toast } from "react-toastify";


export const usePostHelpContactSupport = () => {
  const postHelpContactSupport = useCallback(async (data:any) => {
    try {
      const response = await apiClientTwo.post(`${apiPaths.HELP_SUPPORT}`, data);

      console.log(response?.data, 'responsehelp>>>');
      return response;
    } catch (error) {
      console.log('Error response:', error);
      return error;
    }
  }, []);

  return {
    postHelpContactSupport,
  };
};
